import { useQuery } from '@tanstack/react-query';
import backend from '../services/backend';
import SortableTable from './SortableTable';
import AuditLogDataDetails from './AuditLogDataDetails';
import { formatDateTime } from '../lib/dateFormat';

export default function ResourceAuditLog({ pageId }: { pageId: string }) {
  const query = useQuery({
    queryKey: ['audit-logs', pageId],
    queryFn: () => backend.listAuditLogs(1, 10, { dataFilter: JSON.stringify({ pageId }) }),
  });

  if (query.data?.data.items.length === 0) {
    return null;
  }

  return (
    <>
      <div className="mt-8">
        <h2 className="text-lg font-medium text-gray-900 mb-4 dark:text-zinc-100">Audit Log</h2>

        <div className="overflow-hidden rounded-lg">
          <SortableTable
            storageId="resource-audit-log"
            columns={[
              {
                accessor: 'id',
                label: 'ID',
              },
              {
                accessor: 'createdAt',
                label: 'Created',
                render: (row) => formatDateTime(row.createdAt),
              },
              {
                accessor: 'username',
                label: 'Username',
              },
              {
                accessor: 'data',
                label: 'Details',
                render: (row) => <AuditLogDataDetails data={row} />,
              },
            ]}
            data={query.data?.data.items ?? []}
            rowKey={(row) => row.id}
          />
        </div>
      </div>
    </>
  );
}
